import { render, staticRenderFns } from "./noticeForm.vue?vue&type=template&id=77916b40&scoped=true&"
import script from "./noticeForm.vue?vue&type=script&lang=js&"
export * from "./noticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77916b40",
  null
  
)

export default component.exports